module.exports = __webpack_public_path__ + "img/huggingface.0340c129.png";